export default "https://assets.pclncdn.com/web/next-landing/6889411/_next/static/images/chicago-eda900d81a19c17e024ba156c805eb1c.jpg";